export default __webpack_public_path__ + "static/media/bg-img.5616fa4e.jpg";